<template>
  <div id="app">
    <template v-if="isDataLoaded">
      <ProductEditVue
        v-if="isAdmin"
        :productData="productData"></ProductEditVue>
      <template v-else>
        <ProductListVue
          :productData="productData"
          :shoppingCartData="shoppingCart"
          v-show="navActive === 0" />
        <ShoppingCartVue
          v-show="navActive === 1"
          :shoppingCartData="shoppingCart" />
        <!-- 导航栏 -->
        <van-tabbar v-model="navActive" style="height: 70px; z-index: 99">
          <van-tabbar-item icon="goods-collect">商品</van-tabbar-item>
          <van-tabbar-item icon="shopping-cart">购物车</van-tabbar-item>
        </van-tabbar>
      </template>
    </template>
  </div>
</template>

<script>
import ProductListVue from './views/Product/list.vue'
import ProductEditVue from './views/Product/edit.vue'
import ShoppingCartVue from './views/ShoppingCart/list.vue'
import axios from 'axios'

const SHOPPING_CART_KEY = 'shoppingCart'
export default {
  name: 'App',
  components: {
    ProductListVue,
    ShoppingCartVue,
    ProductEditVue
  },
  data() {
    let shoppingCartCache = localStorage.getItem(SHOPPING_CART_KEY)
    let shoppingCart = []
    if (shoppingCartCache) {
      try {
        shoppingCart = JSON.parse(shoppingCartCache) || []
        if (!Array.isArray(shoppingCart)) {
          shoppingCart = []
        }
      } catch {
        shoppingCart = []
      }
    }

    return {
      navActive: 0,
      productData: [],
      shoppingCart,
      isDataLoaded: false,
      isAdmin: false
    }
  },
  async mounted() {
    /*管理页面 */
    let pathName = window.location.hash.toLowerCase()
    if (pathName === '#/ProductManage'.toLowerCase()) {
      this.isAdmin = true
    }

    let result = await axios.get('/products.json')
    this.productData = result.data
    this.isDataLoaded = true
  },
  watch: {
    shoppingCart(val) {
      localStorage.setItem(SHOPPING_CART_KEY, JSON.stringify(val))
    }
  }
}
</script>

<style></style>
